import { MainConfig } from "../configs/mainConfig";

const generateUsername = (testUsername: boolean = false) => {
  let rdm = Math.random().toString(36).slice(-6);
  if (testUsername === true) {
    return `Tests_${rdm}`;
  } else {
    return `User_${rdm}`;
  }
};

const getOldUserForms = async (username: string): Promise<any> => {
  let date = "2012-01-01T00:00:00";
  let userID = username?.toLocaleLowerCase();
  let urlAPI = `${MainConfig.backendEndpoint}/api/forms/FormData/${date}/${userID}`;
  return await fetch(`${MainConfig.backendEndpoint}/connect/token`, {
    method: "POST",
    body:
      "grant_type=client_credentials&client_id=" +
      MainConfig.apiKey +
      "&client_secret=" +
      MainConfig.apiSecret +
      "&scope: K2Forms",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then(function (resp) {
      // Return the response as JSON
      return resp.json();
    })
    .then(function (data) {
      // Log the API data
      console.log("token", data);
      return fetch(urlAPI, {
        headers: {
          Authorization: data.token_type + " " + data.access_token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
    })
    .then(function (resp) {
      // Return the API response as JSON
      return resp.json();
    })
    .then(function (data) {
      // Log the pet data
      console.log("file", data);
      return data;
    })
    .catch(function (err) {
      // Log any errors
      console.log("something went wrong", err);
    });
};

export { generateUsername, getOldUserForms };
